module.exports = __webpack_public_path__ + "img/mt5-icon1.c738156.png";